var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('aha-antd-button',{attrs:{"variant":"secondary"},on:{"click":_vm.hideQuestionImage}},[(_vm.slideActive.showQuestionImage)?_c('span',[_vm._v(_vm._s(_vm.$t('Hide image')))]):_c('span',[_vm._v(_vm._s(_vm.$t('Show image')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }